<form [formGroup]="componentForm">
	<div class="row mb-3">
		<label class="col-md-4 col-lg-3 col-form-label required">Family Role</label>
		<div class="col-md-8 col-lg-9">
			<ejs-dropdownlist [dataSource]="familyRoleOptions"
							  pmsAutoSelect
							  formControlName="familyRoleId"
							  placeholder="Select Family Role">
			</ejs-dropdownlist>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'familyInformationHeadOfHouseholdFormGroup'">
		<div class="offset-sm-4 offset-md-3 col-md-8 col-lg-9">
			<ejs-checkbox label="Head of Household" formControlName="headOfHousehold"></ejs-checkbox>
		</div>
	</div>
</form>
